import * as React from 'react'
import Provider from '@theme/Provider'

import Component from './FixedDrawerComponent'

import { createRoot, Root } from 'react-dom/client'

let container: HTMLElement | null
let root: Root
let active = false

const FixedDrawer = {
  open: (props: DrawerProps) => {
    container = document.getElementById('portal_root')

    if (root && active) {
      root.unmount()
    }

    if (container) {
      root = createRoot(container)
      root.render(
        <Provider>
          <Component {...props} onClose={FixedDrawer.close} />
        </Provider>
      )
    }

    active = true
  },
  close: () => {
    if (root && active) {
      root.unmount()
      active = false
    }
  },
}

export default FixedDrawer
